import apiClient from './apiClient';

export interface GlobalPromptResponse {
  prompt_text: string;
  file_path: string;
  char_count: number;
  last_modified?: string;
  is_locale_specific: boolean;
  is_default_fallback: boolean;
}

const API_BASE = '/api/v1/admin/prompts';

export const promptService = {
  async getGlobalPrompt(locale?: string): Promise<GlobalPromptResponse> {
    const params = locale ? `?locale=${encodeURIComponent(locale)}` : '';
    const response = await apiClient.get<GlobalPromptResponse>(`${API_BASE}/global${params}`);
    return response.data;
  },

  async updateGlobalPrompt(promptText: string, locale?: string): Promise<{ success: boolean; message: string; char_count: number; locale: string }> {
    const params = locale ? `?locale=${encodeURIComponent(locale)}` : '';
    const response = await apiClient.put(`${API_BASE}/global${params}`, {
      prompt_text: promptText,
    });
    return response.data;
  },

  async listLocales(): Promise<{ locales: string[] }> {
    const response = await apiClient.get<{ locales: string[] }>(`${API_BASE}/locales`);
    return response.data;
  },

  async createLocale(locale: string, promptText?: string): Promise<{ success: boolean; locale: string; message: string; char_count: number }> {
    const response = await apiClient.post(`${API_BASE}/locales`, {
      locale,
      prompt_text: promptText,
    });
    return response.data;
  },
};
